import React from "react";

const ApiProductList = (props) => {
  const { liclassName, children } = props;
  return (
    <ul className="table">
      <li className={liclassName}>{children}</li>
    </ul>
  );
};

export default ApiProductList;
